<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {},
  methods: {},
  beforeDestroy() {
    // 清除定时器以防止内存泄漏
    clearInterval(this.tokenRefreshInterval);
  },
};
</script>

<style>
#app {
  font-family: "Times New Roman", Times, serif, Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
